import styled from "styled-components";

import { WizardProvider, useWizard } from "Wizard";
import Container from "./Container";

function ResetButton() {
  const { resetWizard } = useWizard();
  return (
    <Reset onClick={() => { resetWizard(); window.location.reload(); }}>reset</Reset>
  );
}

function App() {
  return (
    <WizardProvider>
      <Wrapper>
        <Sidebar />
        <Main />
        <Container />
        <ResetButton />
      </Wrapper>
    </WizardProvider>
  );
}

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  position: relative;
  perspective: 1200px;
`;

const Sidebar = styled.div`
  width: 340px;
  min-width: 340px;
  height: 100%;
  background: #182941;
  position: relative;

  &:after {
    content: "";
    display: block;
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    background: radial-gradient(
      calc(100vh * 0.6) circle at 50% 60%,
      rgba(255, 255, 255, 0.1),
      rgba(255, 255, 255, 0)
    );
  }
`;

const Main = styled.div`
  flex: 1;
  height: 100%;
  background: #fff;
`;

const Reset = styled.button`
  position: fixed;
  bottom: 12px;
  left: 12px;
  z-index: 9999;
  appearance: none;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.35);
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-family: inherit;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.7);
  }
`;

export default App;
